import {
  Form,
  required,
  SelectInput,
  useCreate,
  useNotify,
  useRefresh,
} from 'react-admin';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';

import { useDeclineReasonOptions } from '@pumpkincare/wellness';

import { parseAndFormatDate } from '../../../shared/utils';
import { cancelWellnessRenewalModalStyle } from './cancel-wellness-renewal-modal-style';

function CancelWellnessRenewalModal(props) {
  const { onClose, isOpen, wellness = {} } = props;
  const classes = cancelWellnessRenewalModalStyle();
  const [create, { isLoading }] = useCreate();
  const refresh = useRefresh();
  const notify = useNotify();

  const { data: declineReasonOptions } = useDeclineReasonOptions();

  function handleSubmitCancellationReason({ cancellation_reason }) {
    create(
      `cancellations/renewals-v2`,
      {
        data: {
          reasons: [{ decline_enum: cancellation_reason }],
          pet_id: wellness.pet_id,
          decline_list: ['wellness'],
        },
      },
      {
        onSuccess: () => {
          onClose();
          refresh();
        },
        onError: error => {
          notify(
            `There was an error while cancelling the wellness renewal plan: ${error.message}`,
            {
              type: 'warning',
            }
          );
        },
      }
    );
  }

  return (
    <Dialog maxWidth='md' open={isOpen} onClose={onClose}>
      <Form onSubmit={handleSubmitCancellationReason}>
        <DialogTitle>
          <Typography className={classes.modalTitle}>Confirm Non-Renewal</Typography>
          <Typography className={classes.modalSubTitle}>
            {`This plan will not be activated. This pet will no longer have
                coverage as of ${parseAndFormatDate(wellness.end_date)}`}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <div className={classes.informationDiv}>
            <Typography className={classes.information}>PET:</Typography>
            <Typography className={classes.information}>
              {wellness.pet_name}
            </Typography>
          </div>

          <div className={classes.informationDiv}>
            <Typography className={classes.information}>PLAN PERIOD:</Typography>
            <Typography className={classes.information}>
              {`${parseAndFormatDate(wellness.start_date)} - ${parseAndFormatDate(
                wellness.end_date
              )}`}
            </Typography>
          </div>

          <SelectInput
            fullWidth
            validate={required()}
            source='cancellation_reason'
            choices={declineReasonOptions}
            label='Cancellation Reason'
          />
        </DialogContent>
        <DialogActions style={{ justifyContent: 'space-between' }}>
          <Button
            disabled={isLoading}
            onClick={onClose}
            className={classes.cancelButton}
          >
            CANCEL
          </Button>
          <Button
            disabled={isLoading}
            type='submit'
            className={classes.updateButton}
          >
            CONFIRM
          </Button>
        </DialogActions>
      </Form>
    </Dialog>
  );
}

CancelWellnessRenewalModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  wellness: PropTypes.object,
};

export default CancelWellnessRenewalModal;
